<template>
    <Portlet class="right-panel" :fullHeight="true" :noPadding="true">
        <template slot="Title">
            Source
        </template>
        <template slot="Options">
            <!---->
        </template>
        <template slot="Content">
            <WaitingBlock v-if="isLoadingStationBoxes"></WaitingBlock>
            <div v-else id="clock-source">
                <ItemMenuList :isLoading="isLoadingStationBoxes" class="grouped">
                    <template slot="Content">
                        <template v-if="boxSource != null" v-for="section in boxSource">
                            <div :class="['category']" @click='toggleSection(section.key)' :key="`cat-${section.key}`">
                                <i :class="['fas', expandedSections[section.key] == false ? 'fa-chevron-down' : 'fa-chevron-right' ]"></i>
                                <span>{{ section.key }}</span>
                            </div>
                            <b-list-group :class="[ expandedSections[section.key] == false ? 'expanded':'collapsed' ]" :key="`list-${section.key}`">
                                <MenuCard v-for="box in section.items"
                                          :key="box.uid"
                                          :menuItem="box" :href="''"
                                          :disableLink="true"
                                          :isDraggable="true"
                                          :disableDecorator="false">
                                    <template slot="Decorator">
                                        <i class="fas fa-circle" :style="{ color: box.colorCode }"></i>
                                    </template>
                                    <template slot="Badge">
                                        <div>
                                            <b-badge variant="primary" pill>
                                                <span v-if="box.type==Constants.boxTypes.SMARTBOX.value || Constants.boxTypes.SMARTBOX.key.localeCompare(box.type) == 0">
                                                    <i class="fas fa-bolt"></i>
                                                </span>
                                                <span v-else>
                                                    {{box.statistics.trackCount}}
                                                </span>
                                            </b-badge>
                                        </div>
                                    </template>
                                </MenuCard>
                            </b-list-group>
                            <!--<div v-else class="alert alert-info">
                                No Box found
                            </div>-->
                        </template>
                        <div v-else>No Box available</div>
                    </template>
                    <template slot="Actions">
                        <!---->
                    </template>
                </ItemMenuList>
            </div>
        </template>
    </Portlet>
</template>
<script>
    import Vue from 'vue'
    import Translations from '@/store/translations';
    import router from '@/router';
    import EventBus from '@/eventbus';
    import Portlet from '@/components/common/Portlet.vue'
    import WaitingBlock from '@/components/common/WaitingBlock.vue'
    import ItemMenuList from '@/components/common/ItemMenuList.vue'
    import MenuCard from'@/components/common/MenuCard'
    import Constants from "@/store/constants";
    import { mapState } from 'vuex';
    import VueCookie from 'vue-cookie';
    // Tell Vue to use the plugin
    Vue.use(VueCookie);
    export default {
        name: "ClockSourcePanel",
        components: { Portlet, WaitingBlock, ItemMenuList, MenuCard },
        watch: {
            expandedSections: function (value) {
                // console.log("Sections states : ", value);
            }
        },
        computed: {
            Constants: () => Constants,
            ...mapState({
                isLoadingStationBoxes: state => state.loadingStates.isLoadingStationBoxes,
                stationBoxes: state => {
                    if (state.stationBoxes == null) return [];
                    return state.stationBoxes.items;
                },
            }),
            boxSource: function () {
                if (this.stationBoxes == null) return [];
                var boxes = this.stationBoxes.filter(box => {
                    // console.log(box)
                    var boxAllowed = this.allowedBoxTypes.find(function (boxType) {
                        return box.type == boxType.value || box.type.localeCompare(boxType.key) == 0;
                    });
                    if (boxAllowed != null) {
                        // check file type
                        var fileTypeAllowed = this.allowedTrackTypes.find(function (fileType) {
                            return box.trackType != fileType.value && box.trackType.localeCompare(fileType.key) == 0;
                        });
                        return fileTypeAllowed != null;
                    };
                    return false;
                });
                var groups = {};
                boxes.forEach(function (boxItem) {
                    // console.log("Box : " + JSON.stringify(boxItem));
                    var typeKey = (boxItem.trackType || "");
                    if (groups[typeKey] === undefined) {

                        groups[typeKey] = { key: typeKey, expanded: true, items: [] };
                    }
                    groups[typeKey].items.push(boxItem);
                });
                return groups;
            },
        },
        data() {
            var defaultConfig = {
                MUSIC: true,
                JINGLE: true,
                VOICE_TRACK: true,
            };
            var allowedBoxTypes = [Constants.boxTypes.BOX, Constants.boxTypes.SMARTBOX,];
            var allowedTrackTypes = [Constants.trackTypes.MUSIC, Constants.trackTypes.JINGLE, Constants.trackTypes.VOICE_TRACK];
            var configCookie = null;
            try {
                configCookie = JSON.parse(this.$cookie.get('clockSourceConfig') || null) || defaultConfig;
            } catch (e) {
                configCookie = defaultConfig;
            }
            return {
                expandedSections: configCookie, allowedBoxTypes, allowedTrackTypes
            }
        },
        methods: {
            addClockBox(boxUid) {
                EventBus.$emit('AddBoxToClock', boxUid);
            },
            toggleSection(sectionKey) {
                this.expandedSections[sectionKey] = !this.expandedSections[sectionKey];
                this.$cookie.set('clockSourceConfig', JSON.stringify(this.expandedSections));
            },
            onClick() {
                console.log('clicked');
            }
        }
    }
</script>
